import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function resetScroll() {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

/** Keeps route changes starting at the top of the page. */
export function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    resetScroll();
  }, [pathname, search, hash]);

  return null;
}
